"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/MenuItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);









/* Rev 28 S5: an item in Broadcast's own menus (Scheduled, the Send caret, a
 * recipient row), a real menuitem button that looks like the shared
 * TooltipMenuItem of the ··· menu. */
const MenuItem = _react2.default.forwardRef(
  ({ label, desc, iconSrc, isDestructive, className, ...props }, ref) => (
    _react2.default.createElement('button', {
      ref: ref,
      type: "button",
      role: "menuitem",
      className: _classBuilder2.default.call(void 0, 
        'blm-tooltip--menu-item broadcast-menu--item',
        isDestructive && 'blm-tooltip--menu-item--destructive',
        className,
      ),
      ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}

      ,  iconSrc && _react2.default.createElement('img', { src: iconSrc, className: "blm-tooltip--menu-item--icon", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}} ) 
      , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'blm-tooltip--menu-item--label', iconSrc && 'broadcast-menu--label-with-icon'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        ,  label 
        ,  desc && _react2.default.createElement('span', { className: "broadcast-menu--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}},  desc ) 
      )
    )
  ),
)
MenuItem.displayName = 'MenuItem'

exports. default = MenuItem
